import { Component, Input } from "@angular/core";
import { DeviceService } from "../../device.service";

@Component({
	selector: "app-battery-life-metrics",
	templateUrl: "./battery-life-metrics.component.html",
	styleUrls: ["./battery-life-metrics.component.css"],
})
export class BatteryLifeMetricsComponent {
	@Input() deviceData: any;

	percentRemaining: number = 0;
	yearsRemaining: number = 0;
	percentRemainingYears: number = 0;

	constructor(private deviceService: DeviceService) {}

	ngOnInit() {
		this.calculateMetrics();
	}

	calculateMetrics() {
		if (!this.deviceData) 
			return;

		const config = this.deviceData.config_info;
		const inUseAhr = config.inuse_ahr + Number(config.add_inuse_ahr);
		const capacity = config.battery_capacity || 1; 
		const consumedRatio = inUseAhr / (1250 * capacity);
		const remainingRatio = 1 - consumedRatio;

		this.percentRemaining = Math.max(0, Math.min(100, remainingRatio * 100));
		const { percentLifeRemainingYears } = this.deviceService.getBatteryRemainingLifeData(config)
		const maxLifeYears = config.charger_type === this.deviceService.chargerTypes.Fast ? 4 : 5;

		this.yearsRemaining = (percentLifeRemainingYears / 100) * maxLifeYears;
		this.percentRemainingYears = Math.max(0, Math.min(100, percentLifeRemainingYears));
	}
}
